import React, { ReactNode } from 'react';
import { css } from '@emotion/css';
import { color_shades_dark } from '../../constants/colors';
import Button from './Button';
import { breakpoint_small } from '../../constants/breakpoints';
import styled from '@emotion/styled';

const closeIcon = require('../../content/images/close_icon.svg');

interface ModalHeaderProps {
    title: string
    onClose: () => void
    className?: string
    rightText?: string | ReactNode
    rightTextClassName?: string
}

const ModalHeader: React.FC<ModalHeaderProps> = (props) => (
    <div className={props.className ? `${props.className} ${containerStyle}` : containerStyle}>
        <h2>{props.title}</h2>
        <div className={rightSectionStyle}>
            {props.rightText && <span className={props.rightTextClassName ? props.rightTextClassName : rightTextStyle}>{props.rightText}</span>}
            <Button type="button" themes={['end-tight', 'icon']} icon={closeIcon} onClick={props.onClose} />
        </div>
    </div>
);

const containerStyle = css`
    display: flex;
    align-items: center;
    height: 80px;
    border-bottom: 1px solid ${color_shades_dark};
    h2 {
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
        margin: 0 32px;
    }
    button {
        border-left: 1px solid ${color_shades_dark};
        border-radius: 0;
        padding: 0 32px;
        height: 48px;
        img {
            width: 24px;
            height: 24px;
        }
        ${breakpoint_small} {
            padding: 0 16px;
        }
    }
    ${breakpoint_small} {
        h2 {
            font-size: 16px;
            margin: 0 16px 0 32px;
        }
        p {
            font-size: 14px;
        }
    }
`;

const rightSectionStyle = css`
    display: flex;
    align-items: center;
    margin-left: auto;
`;

const rightTextStyle = css`
    font-size: 14px;
    color: ${color_shades_dark};
    margin-right: 16px;
`;

export default ModalHeader;